import { render, staticRenderFns } from "./checkSelector.vue?vue&type=template&id=3620ecb5&scoped=true&"
import script from "./checkSelector.vue?vue&type=script&lang=js&"
export * from "./checkSelector.vue?vue&type=script&lang=js&"
import style0 from "./checkSelector.vue?vue&type=style&index=0&lang=css&"
import style1 from "./checkSelector.vue?vue&type=style&index=1&id=3620ecb5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3620ecb5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3620ecb5')) {
      api.createRecord('3620ecb5', component.options)
    } else {
      api.reload('3620ecb5', component.options)
    }
    module.hot.accept("./checkSelector.vue?vue&type=template&id=3620ecb5&scoped=true&", function () {
      api.rerender('3620ecb5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/components/checkSelector.vue"
export default component.exports